import {useGameState} from '../../hooks/useGameState'
import React, {useEffect, useRef, useState} from 'react'
import {makeStyles} from '@material-ui/styles'
import {
  drawElements,
  get2dContext,
  initialiseContext,
} from '../../helpers/canvas'
import line from '../../helpers/canvas/line'
import circle from '../../helpers/canvas/circle'

const useStyles = makeStyles({
  canvas: {
    ...makeCanvasDimensions(10),
    opacity: 0.8
},
  '@media (orientation: portrait) and (min-height: 640px)': {
    canvas: makeCanvasDimensions(11),
  },
  '@media (orientation: portrait) and (min-height: 720px)': {
    canvas: makeCanvasDimensions(14),
  },
  '@media (orientation: portrait) and (min-height: 812px)': {
    canvas: makeCanvasDimensions(20),
  },
  '@media (orientation: portrait) and (min-height: 1024px)': {
    canvas: makeCanvasDimensions(20),
  },
})

function makeCanvasDimensions(size) {
  const sizeProp = `${size}em`
  return {width: sizeProp, height: sizeProp}
}

export default function Drawing() {
  const [dimensions, setDimensions] = useState(getInitialDimensionsState())
  const [isCanvasInitialised, setCanvasInitialised] = useState(false)
  const elem = useRef()
  const {incorrectTries} = useGameState()
  const dpr = window.devicePixelRatio || 1
  const {canvas} = useStyles()

  useEffect(
    () => updateDimensions(dimensions, elem, setDimensions),
    [dimensions, setDimensions],
  )

  useEffect(
    () => initialise(
      dimensions,
      dpr,
      elem,
      isCanvasInitialised,
      setCanvasInitialised,
    ),
    [dimensions, dpr, elem, isCanvasInitialised, setCanvasInitialised],
  )

  useEffect(
    () => draw(elem, dimensions, dpr, incorrectTries),
    [elem, incorrectTries, dimensions, dpr],
  )

  return (
    <canvas
      className={canvas}
      ref={elem}
      width={dimensions.width * dpr}
      height={dimensions.height * dpr}
    />
  )
}

function getInitialDimensionsState() {
  return {width: 0, height: 0, canDraw: false}
}

function updateDimensions(dimensions, elem, setDimensions) {
  const {width, height} = dimensions
  const {clientWidth, clientHeight} = elem.current

  if (width !== clientWidth || height !== clientHeight) {
    setDimensions({width: clientWidth, height: clientHeight, canDraw: true})
  }
}

function initialise(dimensions, dpr, elem, isInitialised, setInitialised) {
  if (dimensions.canDraw && !isInitialised) {
    initialiseContext(get2dContext(elem), dimensions, dpr)
    setInitialised(true)
  }
}

const DRAWING_ELEMENTS = [
  line({x1: 0.8, y1: 0.9, x2: 0.8, y2: 0.1}),
  line({x1: 0.4, y1: 0.1, x2: 0.8, y2: 0.1}),
  line({x1: 0.7, y1: 0.1, x2: 0.8, y2: 0.2}),
  line({x1: 0.5, y1: 0.1, x2: 0.5, y2: 0.25}),
  circle({x: 0.5, y: 0.315, r: 0.065}),
  line({x1: 0.5, y1: 0.385, x2: 0.5, y2: 0.7}),
  line({x1: 0.5, y1: 0.48, x2: 0.65, y2: 0.5}),
  line({x1: 0.5, y1: 0.48, x2: 0.35, y2: 0.5}),
  line({x1: 0.5, y1: 0.7, x2: 0.6, y2: 0.85}),
  line({x1: 0.5, y1: 0.7, x2: 0.4, y2: 0.85}),
]

function draw(elem, dimensions, dpr, incorrectTries) {
  const context = get2dContext(elem)

  if (dimensions.canDraw) {
    drawElements(
      context,
      dpr,
      dimensions,
      DRAWING_ELEMENTS.slice(0, incorrectTries),
    )
  }
}

